import { mutations } from "@shared/template/StoreTemplates/FilterStoreTemplate"
import { initialState } from "./state"

export default {
  ...mutations,
  setIsEditing(state, payload) {
    state.isEditing = payload
  },
  setLeadToEditId(state, payload) {
    state.leadToEditId = payload
  },
  setSelectedLead(state, payload) {
    state.selectedLead = payload
  },
  clearSelectedLead(state) {
    state.selectedLead = null
  },
  updateLead(state, payload) {
    state.lead = { ...state.lead, ...payload }
  },
  updateCurrentStep: (state, payload) => (state.currentStep = payload),
  setDisabledFieldToEdit(state, payload) {
    state.disabledFieldToEdit = { ...state.disabledFieldToEdit, ...payload }
  },
  setPolling(state, payload) {
    state.polling = payload
  },
  setLastImportation(state, payload) {
    state.lastImportation = payload
  },
  resetLead(state) {
    const init_state = initialState()
    Object.keys(state).forEach(key => {
      state[key] = init_state[key]
    })
  }
}
